import React, { useEffect, useRef, useState } from 'react'

import MultiTalent from '../../../components/Shared/MultiTalent'
import UpcomingClassLanguage from '../../common/Statistic/UpcomingClassLanguage'
import { Icon, Button } from '../../../components/UI'
import FindTutorClassBannerCalendar from './FindTutorClassBannerCalendar'

import { getUserName } from '../../../helpers'

import { classLevels, imagePrefix } from '../../../constants'

const FindTutorClassBanner = ({ classBanner, onCalendar, onDetails }) => {
  const wrapperRef = useRef(null)

  const [isCalendarOpen, setIsCalendarOpen] = useState(false)
  const [heightOfCalendar, setHeightOfCalendar] = useState(0)

  const classLevel =
    classLevels.find((level) => level.value === classBanner.class_banner_level) || classLevels[2]

  const handleToggleCalendar = () => {
    setIsCalendarOpen((prevState) => !prevState)
  }

  useEffect(() => {
    if (wrapperRef.current) {
      setHeightOfCalendar(wrapperRef.current.getBoundingClientRect?.()?.height || 0)
    }
  }, [classBanner, wrapperRef])

  const languagesContent = (classBanner.creator_profile?.languages || []).map((language) => {
    return <UpcomingClassLanguage key={`lang-${language.iso_639_1_code}`} language={language} />
  })

  const currenciesContent = classBanner.payment_preferences.map((currency) => {
    return (
      <li key={`currency-${currency.slug}`} className="flex w-[20px] h-[20px]">
        <img
          src={`/assets/icon/${currency.slug}-icon.svg`}
          alt={currency.name}
          title={currency.name}
          className="w-full h-full"
        />
      </li>
    )
  })

  return (
    <li ref={wrapperRef} className="w-full flex items-stretch justify-center">
      <div className="flex-1 bg-[#FEEBDD] rounded-[10px] flex flex-col items-center p-[10px] border-[#F79009] border-[1px]">
        <div className="w-full flex items-stretch">
          <div className="relative w-[354px] h-[266px] my-auto">
            <video className="w-full h-full rounded-[6px] object-fill" controls>
              <source
                src={classBanner.cover_video ? `${imagePrefix}${classBanner.cover_video}` : ''}
                type="video/mp4"
              />
              Your browser does not support the video tag.
            </video>
          </div>

          <div className="min-h-[266px] flex flex-col items-start bg-[#fff5ee] border-[#ffca84] border-[1px] rounded-[6px] ml-[10px] flex-1 px-[20px] py-[12px]">
            <div className="w-full border-b-[#f674432b] border-b-[1px] flex items-center pb-[10px]">
              <span className="text-base font-semibold text-[#F67443]">
                {classBanner.class_banner_category.name}
              </span>

              <span className="flex items-center text-center text-[#F79009] font-semibold text-xs ml-[10px] mr-[18px] px-[8px] border-[#F79009] border-[1px] rounded-[8px] h-[24px]">
                {classLevel.label}
              </span>

              <div className="ml-auto flex justify-center gap-x-[16px]">
                <div className="flex justify-center items-center">
                  <img
                    aria-hidden="true"
                    className="w-[24px] h-[24px]"
                    src={'/assets/icon/checkbox-multiple-line.svg'}
                    alt=""
                  />
                  <span className="font-normal ml-1 text-sm text-[#F67443]">
                    {classBanner.tutor_stats?.total_bookings || 0}
                  </span>
                </div>

                <div className="flex justify-center items-center">
                  <img
                    aria-hidden="true"
                    className="w-[24px] h-[24px]"
                    src={'/assets/icon/user-green.svg'}
                    alt=""
                  />
                  <span className="font-normal ml-1 text-sm text-[#F67443]">
                    {classBanner.tutor_stats?.total_students || 0}
                  </span>
                </div>

                <div className="flex justify-center items-center">
                  <img
                    aria-hidden="true"
                    className="w-[24px] h-[24px]"
                    src={'/assets/icon/star.svg'}
                    alt=""
                  />
                  <span className="font-normal ml-1 text-sm text-[#F67443]">
                    {classBanner.tutor_stats?.overall_rating_average || 0}
                  </span>
                </div>

                <div className="flex justify-center items-center">
                  <span className="text-[#B733DD] text-sm font-bold">ROI</span>
                  <span className="text-[#F67443] font-semibold ml-1 text-sm">
                    {classBanner.tutor_stats?.roi || 0}%
                  </span>
                </div>

                <div className="flex justify-center items-center">
                  <img
                    aria-hidden="true"
                    className="w-[24px] h-[24px]"
                    src={'/assets/icon/euro-coin.svg'}
                    alt=""
                  />
                  <span className="font-normal ml-1 text-sm text-[#F67443]">
                    {classBanner.price_per_class || 0}
                  </span>
                </div>
              </div>
            </div>

            <div className="w-full flex items-start gap-x-[20px] mt-[10px]">
              <div className="flex-1 flex flex-col items-start">
                <div className="flex items-center">
                  <h4 className="text-2xl font-bold text-[#F67443] mr-[10px]">
                    {getUserName(
                      classBanner.class_banner_creator,
                      classBanner.creator_profile?.display_name,
                      classBanner.creator_profile?.display_last_name
                    )}
                  </h4>

                  {classBanner.multitalent && <MultiTalent />}
                </div>

                {/* TODO */}
                <div className="mt-[8px] flex items-center">
                  <div aria-hidden className="w-[12px] h-[12px] rounded-full bg-[#1AC057]" />

                  <span className="ml-[4px] text-sm font-normal text-primary-100">Online</span>
                </div>

                <p className="mt-[14px] text-sm font-normal text-[#F67443] line-clamp-3">
                  {classBanner.description}
                </p>
              </div>

              <div className="w-[200px] flex flex-col items-start gap-y-[10px]">
                <Button
                  className="flex items-center justify-center w-full h-[32px]"
                  onClick={() => onCalendar(classBanner)}
                >
                  <Icon name="lightning" color="#FDFDFD" className="w-[20px] h-[20px]" />

                  <span className="text-sm text-white font-semibold ml-[8px]">
                    Book Intro Class
                  </span>
                </Button>

                <button className="shadow-button w-full h-[32px] bg-white rounded-[8px] border-[#F79009] border-[1px] flex items-center justify-center text-sm font-semibold font-Inter text-[#F79009] hover:!bg-[#F79009] hover:text-white transition-colors duration-200 ease">
                  Message
                </button>

                <button
                  className="shadow-button w-full h-[32px] bg-white rounded-[8px] border-[#F79009] border-[1px] flex items-center justify-center text-sm font-semibold font-Inter text-[#F79009] hover:!bg-[#F79009] hover:text-white transition-colors duration-200 ease"
                  onClick={() => onDetails(classBanner)}
                >
                  See Profile
                </button>
              </div>
            </div>

            <div className="pt-[12px] mt-auto w-full flex items-center justify-between">
              <div className="flex items-center">
                <img src="/assets/icon/lang.svg" alt="Language" className="mr-[8px]" />

                <ul className="flex items-center gap-x-[4px]">{languagesContent}</ul>
              </div>

              <div className="flex flex-column">
                {/* TODO */}
                <div className="flex items-center ml-auto">
                  <div className="flex items-center mr-[24px]">
                    <img src={'/assets/icon/globleIcon.png'} alt="Origin globe icon" />
                    <img
                      src={`/assets/icon/britain.png`}
                      className="w-[24px] h-[24px] ml-[4px]"
                      alt="Origin country flag"
                    />
                  </div>

                  <div className="flex items-center">
                    <img src={`/assets/icon/homeOrangeIcon.png`} alt="Residence home icon" />
                    <img
                      src={`/assets/icon/poland.png`}
                      className="w-[24px] h-[24px] ml-[4px]"
                      alt="Residence country flag"
                    />
                  </div>
                </div>
              </div>
            </div>

            <div className="mt-[8px] flex items-center">
              <Icon name="hand-coin" color="#F79009" className="w-[24] h-[24px] mr-[8px]" />

              <ul className="flex items-center gap-x-[8px]">{currenciesContent}</ul>
            </div>
          </div>

          <button
            type="button"
            aria-label="Show/hide availability calendar"
            className="cursor-pointer ml-[10px] w-[48px] flex flex-col items-center justify-center border-[1px] border-[#FFCA84] rounded-[6px] bg-[#FFF5EE] group/calendarButton text-primary-button hover:!bg-primary-button-hover hover:!border-primary-button-hover hover:!text-white transition-colors duration-200 ease"
            onClick={handleToggleCalendar}
          >
            <Icon name="calendar-line" className="w-[20px] h-[20px]" />

            <Icon
              name="chevron-down"
              className={`w-[20px] h-[20px] mt-[8px] ${isCalendarOpen ? 'rotate-90' : 'rotate-[-90deg]'}`}
            />
          </button>
        </div>
      </div>

      {isCalendarOpen && (
        <FindTutorClassBannerCalendar
          classBanner={classBanner}
          heightOfCalendar={heightOfCalendar}
          onCalendar={onCalendar}
        />
      )}
    </li>
  )
}

export default FindTutorClassBanner
